import { useState, useRef, useCallback } from "react";
import useDebouncedCallback from "./use-debounced-callback.js";
import useIsMounted from "./use-is-mounted.js";
const initialFetchState = {
  loading: false,
  predictions: []
};
const usePlacesAutocomplete = ({
  atlas,
  onError
}) => {
  const debounceMs = 200;
  const [{ loading, predictions }, setFetchState] = useState(initialFetchState);
  const predictionsRequestId = useRef(0);
  const isMounted = useIsMounted();
  const clearPredictions = useCallback(() => {
    predictionsRequestId.current++;
    setFetchState(initialFetchState);
  }, []);
  const updatePredictions = useDebouncedCallback(
    async ({ input, countryCodes }) => {
      if (!atlas) {
        return;
      }
      if (!isMounted()) {
        return;
      }
      if (!input) {
        clearPredictions();
        return;
      }
      const requestId = ++predictionsRequestId.current;
      setFetchState((state) => ({ ...state, loading: true }));
      let newPredictions;
      try {
        newPredictions = await atlas.predict({ input, countryCodes });
      } catch (error) {
        if (onError) {
          onError(error);
        } else {
          console.error(error);
        }
      } finally {
        const isMostRecentRequest = requestId === predictionsRequestId.current;
        if (isMounted() && isMostRecentRequest) {
          setFetchState((state) => ({
            loading: false,
            // set new predictions if fetched properly, else keep current predictions
            predictions: newPredictions || state.predictions
          }));
        }
      }
    },
    [atlas, onError],
    debounceMs
  );
  return {
    predictions,
    loading,
    updatePredictions,
    clearPredictions
  };
};
export {
  usePlacesAutocomplete as default
};
//# sourceMappingURL=use-places-autocomplete.js.map
